(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-cart-overlay]');
      this.closeBtn = this.querySelector('[data-cart-close]');
      this.panel = this.querySelector('.cart-drawer__panel');
      this.statusEl = this.querySelector('[data-cart-status]');
      this.inertedEls = [];

      document.addEventListener('cart:open', (e) => this.open(e));
      document.addEventListener('cart:close', () => this.close());
      document.addEventListener('cart:refresh', () => this.refresh());

      this.overlay.addEventListener('click', () => this.close());
      this.closeBtn.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });

      // Trap Tab focus within the panel while open (fallback for browsers
      // without inert; with inert the background is already skipped).
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
        const focusable = this.getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Bind the controls on the initially server-rendered cart so the
      // quantity and remove buttons work on first open, not only after a refresh.
      this.bindCartEvents();

      // Closed by default: hide the drawer from assistive tech and the tab order.
      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
    }

    getFocusable() {
      return Array.from(this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter((el) => el.getClientRects().length > 0);
    }

    open(event) {
      // Idempotent: a second open() while already open (e.g. two in-flight
      // quick-adds both resolving) must NOT re-run setBackgroundInert, which
      // would reset inertedEls to empty (everything is already inert) and leave
      // the page stuck inert after a single close().
      const wasOpen = this.classList.contains('is-open');
      if (!wasOpen) {
        this.trigger = document.activeElement;
      }
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (!wasOpen) {
        this.inert = false;
        this.removeAttribute('aria-hidden');
        this.setBackgroundInert(true);
        if (this.closeBtn) this.closeBtn.focus();
      }
      // Announce a message passed by the trigger (e.g. "Added to your cart").
      // This live region lives inside the drawer, which is never inert while
      // open, so the announcement is reliable even though <main> is inert.
      if (this.statusEl) {
        this.statusEl.textContent = '';
        if (event && event.detail && event.detail.message) {
          const msg = event.detail.message;
          requestAnimationFrame(() => { this.statusEl.textContent = msg; });
        }
      }
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      this.setBackgroundInert(false);
      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
      if (this.statusEl) this.statusEl.textContent = '';
      if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus();
      }
    }

    setBackgroundInert(state) {
      if (state) {
        this.inertedEls = [];
        Array.from(document.body.children).forEach((el) => {
          if (el === this || el.hasAttribute('inert')) return;
          el.setAttribute('inert', '');
          this.inertedEls.push(el);
        });
      } else {
        this.inertedEls.forEach((el) => el.removeAttribute('inert'));
        this.inertedEls = [];
      }
    }

    async refresh() {
      try {
        const response = await fetch('/?section_id=cart-drawer-content');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-content]');
        const target = this.querySelector('[data-cart-content]');
        if (newContent && target) {
          target.innerHTML = newContent.innerHTML;
          this.bindCartEvents();
        }
        this.updateCartCount();
      } catch (error) {
        console.error('Cart refresh failed:', error);
      }
    }

    async updateCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(badge => {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        });
      } catch (e) {}
    }

    bindCartEvents() {
      this.querySelectorAll('[data-qty-btn]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.lineKey;
          const delta = parseInt(btn.dataset.qtyDelta);
          const countEl = btn.closest('.cart-item__quantity').querySelector('[data-qty-count]');
          const currentQty = parseInt(countEl.textContent);
          const newQty = currentQty + delta;
          if (newQty < 0) return;
          await this.updateQuantity(key, newQty);
        });
      });

      this.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', async () => {
          await this.updateQuantity(btn.dataset.lineKey, 0);
        });
      });

      const continueBtn = this.querySelector('[data-continue-shopping]');
      if (continueBtn) {
        continueBtn.addEventListener('click', () => this.close());
      }
    }

    async updateQuantity(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        console.error('Quantity update failed:', error);
      }
    }
  }
  customElements.define('cart-drawer', CartDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsells"] && !Shopify.designMode) return;
  try {
    class CartUpsells extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === '1') return;
      this.dataset.loaded = '1';
      this.body = this.querySelector('[data-upsell-body]');
      // Self-contained interactions: the upsells can appear on pages that do
      // not render product cards (e.g. /cart), where the shared product-card
      // click handler is absent. stopPropagation prevents a double-fire on
      // pages where that handler is also present.
      this.addEventListener('click', (e) => this.onClick(e));
      this.load();
    }

    onClick(e) {
      const qa = e.target.closest('[data-quick-add]');
      if (qa && qa.dataset.variantId) {
        e.preventDefault();
        e.stopPropagation();
        this.quickAdd(qa);
        return;
      }
      const qv = e.target.closest('[data-quick-view]');
      if (qv && qv.dataset.productUrl) {
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent('quick-view:open', { detail: { url: qv.dataset.productUrl } }));
      }
    }

    async quickAdd(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { message: btn.dataset.addedMessage } }));
      } catch (err) {
        if (btn.dataset.productUrl) window.location.href = btn.dataset.productUrl;
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }

    buildUrl(intent) {
      const base = this.dataset.recUrl;
      const pid = encodeURIComponent(this.dataset.productId);
      const limit = encodeURIComponent(this.dataset.limit || '10');
      const section = encodeURIComponent(this.dataset.section || 'cart-recommendations');
      return base + '?section_id=' + section + '&product_id=' + pid + '&limit=' + limit + '&intent=' + intent;
    }

    async fetchCards(intent) {
      try {
        const res = await fetch(this.buildUrl(intent));
        if (!res.ok) return null;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = doc.querySelector('[data-upsell-cards]');
        if (cards && cards.querySelector('[data-upsell-card]')) return cards.innerHTML;
        return null;
      } catch (e) {
        return null;
      }
    }

    async load() {
      if (!this.dataset.productId || !this.body) {
        this.hidden = true;
        return;
      }
      let html = await this.fetchCards('complementary');
      if (!html) html = await this.fetchCards('related');
      if (html) {
        this.body.innerHTML = html;
        this.hidden = false;
      } else {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('cart-upsells')) {
    customElements.define('cart-upsells', CartUpsells);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-predictive-input]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.empty = this.querySelector('[data-predictive-empty]');
      this.footer = this.querySelector('[data-predictive-footer]');
      this.closeBtn = this.querySelector('[data-predictive-close]');
      this.seeAllLabel = this.dataset.seeAllLabel || 'See all results';
      this.unavailableLabel = this.dataset.unavailableLabel || '';
      this.noResultsLabel = this.dataset.noResultsLabel || '';
      this.productsLabel = this.dataset.productsLabel || 'Products';
      this.pagesLabel = this.dataset.pagesLabel || 'Pages';
      this.articlesLabel = this.dataset.articlesLabel || 'Articles';
      const formEl = this.querySelector('form');
      this.searchAction = (formEl && formEl.getAttribute('action')) || '/search';
      this.trigger = null;
      this.debouncedQuery = this.debounce(this.runQuery.bind(this), 200);
      this.input.addEventListener('input', this.debouncedQuery);
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      if (formEl) {
        formEl.addEventListener('submit', () => {
          // RET-84: canonicalize casing before the full results page request.
          const normalized = this.normalizeQuery(this.input.value);
          if (this.input.value !== normalized) this.input.value = normalized;
        });
      }
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.hide(true));
      document.addEventListener('click', this.onDocumentClick.bind(this));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) this.hide(true); });
    }

    normalizeQuery(value) {
      return String(value || '').trim().toLocaleLowerCase('en');
    }

    show() { this.trigger = document.activeElement; this.hidden = false; this.input.focus(); }
    hide(returnFocus) {
      this.hidden = true;
      this.results.hidden = true;
      this.results.innerHTML = '';
      if (this.empty) this.empty.hidden = true;
      if (this.footer) { this.footer.hidden = true; this.footer.innerHTML = ''; }
      this.input.value = '';
      this.input.setAttribute('aria-expanded', 'false');
      if (this.status) this.status.textContent = '';
      if (returnFocus && this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    }
    onDocumentClick(e) { if (!this.contains(e.target) && !this.hidden) this.hide(); }

    debounce(fn, wait) {
      let timer;
      return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), wait); };
    }

    async runQuery() {
      const q = this.normalizeQuery(this.input.value);
      if (q.length < 2) {
        this.results.hidden = true;
        this.results.innerHTML = '';
        if (this.footer) { this.footer.hidden = true; this.footer.innerHTML = ''; }
        if (this.empty) this.empty.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        if (this.status) this.status.textContent = '';
        return;
      }
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last`;
        const r = await fetch(url);
        if (!r.ok) throw new Error('search request failed');
        const data = await r.json();
        this.render(data.resources.results, q);
      } catch (err) {
        this.results.hidden = true;
        this.results.innerHTML = '';
        if (this.footer) { this.footer.hidden = true; this.footer.innerHTML = ''; }
        this.input.setAttribute('aria-expanded', 'true');
        if (this.empty) {
          this.empty.textContent = this.unavailableLabel;
          this.empty.hidden = false;
        }
        if (this.status) this.status.textContent = this.unavailableLabel;
      }
    }

    render(results, query) {
      const products = results.products || [];
      const pages = results.pages || [];
      const articles = results.articles || [];
      const total = products.length + pages.length + articles.length;

      this.input.setAttribute('aria-expanded', 'true');

      if (total === 0) {
        this.results.hidden = true;
        this.results.innerHTML = '';
        if (this.footer) { this.footer.hidden = true; this.footer.innerHTML = ''; }
        if (this.empty) {
          this.empty.textContent = this.noResultsLabel.replace('[query]', query);
          this.empty.hidden = false;
        }
        if (this.status) this.status.textContent = this.noResultsLabel.replace('[query]', query);
        return;
      }

      let html = '';

      if (products.length) {
        html += `<div role="group" aria-label="${this.escape(this.productsLabel)}"><p class="predictive-search__group-heading" aria-hidden="true">${this.escape(this.productsLabel)}</p>`;
        html += products.map(p => `
          <a href="${this.escape(p.url)}" class="predictive-search__item" role="option">
            ${p.image ? `<img src="${this.escape(p.image)}" alt="" width="48" height="48">` : `<div class="predictive-search__item-img-placeholder" style="width:48px;height:48px"></div>`}
            <div>
              <div class="predictive-search__item-title">${this.escape(p.title)}</div>
              ${p.price ? `<div class="predictive-search__item-price">${this.escape(p.price)}</div>` : ''}
            </div>
          </a>
        `).join('');
        html += `</div>`;
      }

      if (pages.length) {
        html += `<div role="group" aria-label="${this.escape(this.pagesLabel)}"><p class="predictive-search__group-heading" aria-hidden="true">${this.escape(this.pagesLabel)}</p>`;
        html += pages.map(p => `
          <a href="${this.escape(p.url)}" class="predictive-search__item" role="option">
            <div class="predictive-search__item-title">${this.escape(p.title)}</div>
          </a>
        `).join('');
        html += `</div>`;
      }

      if (articles.length) {
        html += `<div role="group" aria-label="${this.escape(this.articlesLabel)}"><p class="predictive-search__group-heading" aria-hidden="true">${this.escape(this.articlesLabel)}</p>`;
        html += articles.map(a => `
          <a href="${this.escape(a.url)}" class="predictive-search__item" role="option">
            <div class="predictive-search__item-title">${this.escape(a.title)}</div>
          </a>
        `).join('');
        html += `</div>`;
      }

      this.results.innerHTML = html;
      this.results.hidden = false;
      if (this.empty) this.empty.hidden = true;
      if (this.footer) {
        const seeAllUrl = `${this.searchAction}?q=${encodeURIComponent(this.normalizeQuery(query))}`;
        this.footer.innerHTML = `<a href="${this.escape(seeAllUrl)}" class="predictive-search__see-all">${this.escape(this.seeAllLabel)}</a>`;
        this.footer.hidden = false;
      }
      if (this.status) {
        this.status.textContent = total === 1 ? '1 result found' : `${total} results found`;
      }
    }

    escape(s) {
      const div = document.createElement('div');
      div.textContent = s == null ? '' : String(s);
      return div.innerHTML;
    }

    onKeydown(e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.focusNext();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.focusPrev();
      }
    }

    focusable() { return Array.from(this.results.querySelectorAll('.predictive-search__item')); }
    focusNext() {
      const items = this.focusable();
      if (!items.length) return;
      const current = items.findIndex(i => i.classList.contains('is-focused'));
      const next = items[(current + 1) % items.length];
      items.forEach(i => i.classList.remove('is-focused'));
      next.classList.add('is-focused');
      next.focus();
    }
    focusPrev() {
      const items = this.focusable();
      if (!items.length) return;
      const current = items.findIndex(i => i.classList.contains('is-focused'));
      const prev = items[(current - 1 + items.length) % items.length];
      items.forEach(i => i.classList.remove('is-focused'));
      prev.classList.add('is-focused');
      prev.focus();
    }
  }
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cardActionsBound) return;
    window.__cardActionsBound = true;

    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-quick-add]');
      if (qa && qa.dataset.variantId) {
        e.preventDefault();
        quickAdd(qa);
        return;
      }
      var qv = e.target.closest('[data-quick-view]');
      if (qv && qv.dataset.productUrl) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('quick-view:open', { detail: { url: qv.dataset.productUrl } }));
      }
    });

    async function quickAdd(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { message: btn.dataset.addedMessage } }));
      } catch (err) {
        var card = btn.closest('.product-card');
        var link = card ? card.querySelector('.product-card__image-link') : null;
        var href = (link && link.getAttribute('href')) || btn.dataset.productUrl;
        if (href) window.location.href = href;
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    class QuickViewModal extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-quick-view-overlay]');
      this.closeBtn = this.querySelector('[data-quick-view-close]');
      this.panel = this.querySelector('.quick-view__panel');
      this.body = this.querySelector('[data-quick-view-body]');
      this.inertedEls = [];
      this.trigger = null;
      this.loadingLabel = this.dataset.loadingLabel || 'Loading';
      this.errorLabel = this.dataset.errorLabel || 'Sorry, we could not load this product. Please try the product page.';

      document.addEventListener('quick-view:open', (e) => this.open(e));
      document.addEventListener('quick-view:close', () => this.close());

      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
        const focusable = this.getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
    }

    getFocusable() {
      return Array.from(this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter((el) => el.getClientRects().length > 0);
    }

    async open(event) {
      const url = event && event.detail ? event.detail.url : null;
      if (!url) return;
      // Idempotent inert handling (mirrors cart-drawer): a second open() while
      // already open must not re-run setBackgroundInert.
      const wasOpen = this.classList.contains('is-open');
      if (!wasOpen) {
        this.trigger = document.activeElement;
      }
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (!wasOpen) {
        this.inert = false;
        this.removeAttribute('aria-hidden');
        this.setBackgroundInert(true);
      }
      this.body.innerHTML = '<div class="quick-view__loading"><div class="quick-view__spinner" role="status" aria-label="' + this.loadingLabel + '"></div></div>';
      if (this.closeBtn) this.closeBtn.focus();

      try {
        const sep = url.indexOf('?') === -1 ? '?' : '&';
        const res = await fetch(url + sep + 'section_id=quick-view');
        if (!res.ok) throw new Error('quick view failed');
        const html = await res.text();
        if (!this.classList.contains('is-open')) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-qv-product]');
        if (content) {
          this.body.innerHTML = '';
          this.body.appendChild(content);
        } else {
          this.body.innerHTML = html;
        }
        const focus = this.getFocusable();
        if (focus.length) focus[0].focus();
      } catch (err) {
        if (!this.classList.contains('is-open')) return;
        this.body.innerHTML = '<p class="quick-view__error" role="alert">' + this.errorLabel + '</p>';
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      this.setBackgroundInert(false);
      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
      this.body.innerHTML = '';
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    }

    setBackgroundInert(state) {
      if (state) {
        this.inertedEls = [];
        Array.from(document.body.children).forEach((el) => {
          if (el === this || el.hasAttribute('inert')) return;
          el.setAttribute('inert', '');
          this.inertedEls.push(el);
        });
      } else {
        this.inertedEls.forEach((el) => el.removeAttribute('inert'));
        this.inertedEls = [];
      }
    }
  }
  if (!customElements.get('quick-view-modal')) {
    customElements.define('quick-view-modal', QuickViewModal);
  }

  class QuickViewProduct extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-qv-price]');
      this.priceCurrent = this.querySelector('[data-qv-price-current]');
      this.priceCompare = this.querySelector('[data-qv-price-compare]');
      this.addBtn = this.querySelector('[data-qv-add]');
      this.addText = this.querySelector('[data-qv-add-text]');
      this.errorEl = this.querySelector('[data-qv-error]');
      this.specialOrderNoteEl = this.querySelector('[data-qv-special-order-note]');
      this.imageEl = this.querySelector('.qv-product__img');
      this.optionInputs = Array.from(this.querySelectorAll('[data-qv-option-input]'));
      this.addLabel = this.addBtn ? this.addBtn.dataset.addLabel : '';
      this.soldLabel = this.addBtn ? this.addBtn.dataset.soldLabel : '';
      this.addedMessage = this.addBtn ? this.addBtn.dataset.addedMessage : '';
      this.currency = this.dataset.currency || 'CAD';
      this.locale = this.dataset.locale || 'en-CA';
      this.unavailableLabel = this.dataset.unavailableLabel || 'Unavailable';

      try {
        this.variants = JSON.parse(this.querySelector('[data-qv-variant-json]').textContent);
      } catch (e) {
        this.variants = [];
      }

      this.optionInputs.forEach((input) => input.addEventListener('change', () => this.onChange()));
      if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());
      this.updateOptionAvailability();
    }

    fmt(cents) {
      const amount = cents / 100;
      try {
        return amount.toLocaleString(this.locale, { style: 'currency', currency: this.currency, currencyDisplay: 'narrowSymbol' });
      } catch (e) {
        return amount.toLocaleString(this.locale, { style: 'currency', currency: this.currency });
      }
    }

    onChange() {
      const selected = this.optionInputs.filter((i) => i.checked).map((i) => i.value);
      this.optionInputs.forEach((input) => {
        const label = this.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-selected', input.checked);
      });
      const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      this.updatePrice(variant);
      this.updateAvailability(variant);
      this.updateImage(variant);
      this.updateSpecialOrder(variant);
      this.updateOptionAvailability();
    }

    updatePrice(variant) {
      if (!variant || !this.priceCurrent) return;
      this.priceCurrent.textContent = this.fmt(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      this.priceCurrent.classList.toggle('qv-product__price-current--sale', !!onSale);
      if (this.priceCompare) {
        if (onSale) {
          this.priceCompare.textContent = this.fmt(variant.compare_at_price);
          this.priceCompare.hidden = false;
        } else {
          this.priceCompare.textContent = '';
          this.priceCompare.hidden = true;
        }
      }
    }

    updateAvailability(variant) {
      if (!this.addBtn) return;
      if (variant) {
        this.addBtn.dataset.variantId = variant.id;
        this.addBtn.disabled = !variant.available;
        if (this.addText) this.addText.textContent = variant.available ? this.addLabel : this.soldLabel;
      } else {
        this.addBtn.disabled = true;
        if (this.addText) this.addText.textContent = this.soldLabel;
      }
    }

    updateImage(variant) {
      if (!variant || !variant.featured_image || !this.imageEl) return;
      const src = variant.featured_image.src;
      const sep = src.indexOf('?') === -1 ? '?' : '&';
      this.imageEl.removeAttribute('srcset');
      this.imageEl.removeAttribute('sizes');
      this.imageEl.src = src + sep + 'width=600';
    }

    updateSpecialOrder(variant) {
      if (!this.specialOrderNoteEl) return;
      this.specialOrderNoteEl.hidden = !(variant && variant.special_order);
    }

    updateOptionAvailability() {
      const selected = this.optionInputs.filter((i) => i.checked).map((i) => i.value);
      this.optionInputs.forEach((input) => {
        const idx = parseInt(input.dataset.qvOptionIndex, 10);
        const hasAvailable = this.variants.some((v) => {
          if (!v.available) return false;
          if (v.options[idx] !== input.value) return false;
          return v.options.every((opt, i) => i === idx || selected[i] == null || opt === selected[i]);
        });
        const label = this.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.toggle('qv-variant-btn--unavailable', !hasAvailable);
          let note = label.querySelector('[data-unavail-note]');
          if (!hasAvailable) {
            if (!note) {
              note = document.createElement('span');
              note.className = 'visually-hidden';
              note.setAttribute('data-unavail-note', '');
              label.appendChild(note);
            }
            note.textContent = ' (' + this.unavailableLabel + ')';
          } else if (note) {
            note.textContent = '';
          }
        }
      });
    }

    async add() {
      if (!this.addBtn || this.addBtn.disabled) return;
      const id = this.addBtn.dataset.variantId;
      this.addBtn.classList.add('is-loading');
      this.addBtn.disabled = true;
      if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Could not add to cart.');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('quick-view:close'));
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { message: this.addedMessage } }));
      } catch (e) {
        if (this.errorEl) { this.errorEl.textContent = e.message; this.errorEl.hidden = false; }
        this.addBtn.classList.remove('is-loading');
        this.addBtn.disabled = false;
      }
    }
  }
  if (!customElements.get('quick-view-product')) {
    customElements.define('quick-view-product', QuickViewProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
